import { render, staticRenderFns } from "./P002.vue?vue&type=template&id=92ea8266"
import script from "./P002.vue?vue&type=script&lang=js"
export * from "./P002.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports